export const TextFieldSx = {
  "& .MuiInputBase-root": {
    color: "white",
  },
  "& .MuiInputLabel-root": {
    color: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0 100px #000 inset",
      WebkitTextFillColor: "white",
      caretColor: "white",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "white",
  },
};

export const SignInButtonSx = {
  borderColor: "white",
  color: "white",
  "&:hover": {
    borderColor: "white",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
};

export const SignInBox1Sx = {
  display: "flex",
  alignItems: "center",
  paddingTop: "10%",
  height: "100vh",
  flexDirection: "column",
};

export const SignInBox2Sx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  flexDirection: "column",
  width: "300px",
  gap: "20px",
};
